import { render, staticRenderFns } from "./InfraBase.vue?vue&type=template&id=87cfc992&scoped=true&"
import script from "./InfraBase.vue?vue&type=script&lang=js&"
export * from "./InfraBase.vue?vue&type=script&lang=js&"
import style0 from "./InfraBase.vue?vue&type=style&index=0&id=87cfc992&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cfc992",
  null
  
)

export default component.exports